export class User {
    nom: string ="";
    email:string="";
    password:string="";
    tel:string="";
    role:string="2";
    _id:string;
 }